import { fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import ControllerBase from '../../../../global/js/ControllerBase';
export default class ControllerShopFilterStage extends ControllerBase {
	private readonly componentName = 'o-shop-filter-stage';

	/** A list of dom element references available to this component */
	private readonly componentRefs = {
		filterSelect: 'filterSelect',
		filterBar: 'filterBar',
		filterItems: 'filterItems',
		filterList: 'filterList',
	};

	constructor(element: HTMLElement) {
		super(element);

		this.observeFilterChange();
	}

	private observeFilterChange(): void {
		const selectWrapper = this.$references[this.componentRefs.filterSelect];

		selectWrapper &&
			fromEvent(selectWrapper, 'change')
				.pipe(
					map((e: Event) => {
						return (e && e.target) as HTMLSelectElement;
					}),
				)
				.subscribe((selectElem: HTMLSelectElement) => {
					if (selectElem) {
						const filterBar = this.$references[this.componentRefs.filterBar];

						const filterListItemActive = filterBar.querySelectorAll("li[data-uk-filter-control='filter: ." + selectElem.value + "']");
						if (filterListItemActive && filterListItemActive.length) {
							// simulate a click on the hidden filter anchor for UIkit
							const filterActive = filterListItemActive[0].getElementsByTagName<'a'>('a');
							if (filterActive && filterActive.length) {
								filterActive[0].click();
							}
						} else {
							// un-filter the list by selecting all
							const first = filterBar.querySelectorAll<'li'>('li');
							if (first && first.length && first[0].children && first[0].children.length) {
								const selectAllAnchor = first[0].children[0] as HTMLAnchorElement;
								selectAllAnchor.click();
							}
						}
					}
				});
	}
}
